import * as http from "@/api/apiCom/request";
import { useDemoStore } from "@/pinia/index";
const store = useDemoStore();
//物流方式
export const getWay = async () => {
  let res = await http.postJson("/v2/shipment/getShippingWaySelect", {
    token: store.token,
  });
  return res.data || [];
};
//运输单列表（内部员工）
export const soList = async (param = {}) => {
  let res = await http.postJson("/v2/shipment/index", {
    token: store.token,
    ...param,
  });
  return res;
};
//PO列表（外部采购运输单）
export const poList = async (param = {}) => {
  let res = await http.postJson("/v2/shipment/CustomerGetPurchaseList", {
    token: store.token,
    ...param,
  });
  return res;
};
//运单型号
export const getTask = async (param = {}) => {
  let res = await http.postJson("/v2/shipment/getTaskInfo", {
    token: store.token,
    ...param,
  });
  return res.data || [];
};
//打包箱子
export const getBox = async (id) => {
  let res = await http.postJson("/v2/shipment/getPackageItem", {
    token: store.token,
    Shiptask_id: id,
  });
  let arr = (res.data || []).map((el) => {
    let obj = { ...el };
    obj["size"] = `${el.long || 0}*${el.wide || 0}*${el.high || 0} cm`;
    obj["net"] = `${el.netWeight} kg`;
    let str = numPoint(countVal(el.long, el.wide, "mul"), 3);
    str = numPoint(countVal(str, el.high, "mul"), 3); //最多保留3位小数
    str = numPoint(str / 5000, 3);
    obj["volume"] = str + " kg";
    return obj;
  });
  return arr;
};
/**
 * 截取小数点几位
 * @param {amount}  被转换值
 * @param {many}  小数位数
 * @param {rounding} 是否要四舍五入
 * @returns
 */
const numPoint = (amount, many = 2, rounding = false) => {
  let result = amount;
  let num = "1";
  if (typeof amount === "number" && !isNaN(amount)) {
    for (let i = 0; i < many; i++) {
      num += "0";
    }

    if (rounding) {
      //小数点第many+1位四舍五入
      let num2 = num + "0";
      num = Number(num);
      let a = (
        Math.trunc((amount * Number(num2)).toPrecision(12)) / 10
      ).toFixed(1);
      let arr = a.split(".");
      let integer = Number(arr[0]);
      let point = Number(arr[1]);

      if (point < 5) {
        result = integer / num;
      } else {
        result = (integer + 1) / num;
      }
    } else {
      num = Number(num);
      result = Math.trunc((amount * num).toPrecision(12)) / num;
    }
  }
  return result;
};
//加/减/乘法计算
const countVal = (num, num1, str = "add") => {
  let val = Math.trunc((Number(num) * 10000).toPrecision(12));
  let val1 = Math.trunc((Number(num1) * 10000).toPrecision(12));
  let res = 0;
  if (str == "add") {
    res = (val + val1) / 10000;
  } else if (str == "sub") {
    res = (val - val1) / 10000;
  } else if (str == "mul") {
    res = (val * val1) / 100000000;
  }
  return res;
};